module.exports = "https://cdn.hellotech.com/client-assets/featured-in_67c47a9e4275623c6fe07909aa947636.png";